var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 61,
    viewBox: "0 0 46 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3160_42001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0536 21.8527L13.0025 2.64284C11.0025 1.31961 9.0593 0.646484 7.23544 0.646484C3.22976 0.646484 0.644531 3.83375 0.644531 8.75848V52.5287C0.644531 57.4592 3.22976 60.6407 7.23544 60.6407C9.0593 60.6407 11.0025 59.9676 13.0025 58.6444L42.0536 39.4287C44.3377 37.9156 45.6445 35.7409 45.6445 33.4569V27.7267C45.6104 25.4427 44.332 23.3486 42.0536 21.8412V21.8527Z",
    fill: "#3E515B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.786 33.4694V27.7738H40.0076L11.9849 9.23699C6.75195 5.77357 2.50195 7.8102 2.50195 13.782V52.5355C2.50195 58.5073 6.74627 60.5439 11.9849 57.0748L41.036 37.8591C42.8713 36.6452 43.786 35.0573 43.786 33.4637V33.4694Z",
    fill: "#596C6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50195 48.1392V10.0186C2.50195 4.04675 6.74627 2.01012 11.9849 5.47929L41.036 24.6892C44.7008 27.1113 44.7008 31.0465 41.036 33.4743L11.9849 52.69C6.74627 56.1534 2.50195 54.1225 2.50195 48.1507V48.1392Z",
    fill: "#85998E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50195 46.8846V8.75819C2.50195 2.78638 6.75195 0.755506 11.9849 4.21893L41.036 23.4288C44.7008 25.8509 44.7008 29.7861 41.036 32.2139L11.9849 51.4296C6.74627 54.893 2.50195 52.8621 2.50195 46.8903V46.8846Z",
    fill: "#748C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63092 5.55347C9.63092 5.55347 4.58546 4.95513 4.62523 10.599C4.65932 16.2486 6.22751 17.9228 7.68205 18.78C7.68205 18.78 5.48887 19.7293 5.48887 29.3889C5.48887 40.1359 5.19342 47.7301 9.33546 48.3572C13.4775 48.9843 29.2957 40.9298 27.0343 37.3571C27.0343 37.3571 34.2332 35.8843 38.8525 31.253C42.1423 27.9564 42.4946 26.9611 35.2389 21.6049C32.1991 19.3611 9.6366 5.54771 9.6366 5.54771L9.63092 5.55347Z",
    fill: "#98AD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9849 7.35441L41.036 26.5701C42.2633 27.3813 43.0645 28.3593 43.4735 29.3891C44.286 27.3295 43.4735 25.0455 41.036 23.4288L11.9849 4.21892C6.75195 0.755506 2.50195 2.78638 2.50195 8.75819V11.8994C2.50195 5.92762 6.74627 3.89099 11.9849 7.35441Z",
    fill: "#C7D6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63077 4.08175C9.64213 4.87569 8.52849 5.53155 7.14213 5.54881C5.76145 5.56607 4.63077 4.93322 4.62509 4.13928C4.61372 3.34534 5.72736 2.68948 7.11372 2.67222C8.50009 2.65496 9.62509 3.28781 9.63077 4.08175Z",
    fill: "#EDF4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50195 19.1391L6.58718 18.5293L2.50195 22.1481V19.1391Z",
    fill: "#C7D6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50142 17.582L6.58665 18.5256L2.50142 20.5967L1.73438 19.1354L2.50142 17.582Z",
    fill: "#3E515B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8104 40.2342L33.7592 38.4047L28.8672 37.8984L30.8104 40.2342Z",
    fill: "#C7D6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8274 39.5611C32.7024 39.5611 33.9695 38.4853 34.1513 37.8984H28.8672L31.8274 39.5611Z",
    fill: "#3E515B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.152 37.8984L31.8281 39.5611L34.2315 43.013L36.6349 40.7693L34.152 37.8984Z",
    fill: "#3E515B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.696 26.2657C42.3494 26.7548 41.4403 26.703 40.6619 26.1449C39.8892 25.5869 39.5369 24.7354 39.8835 24.2406C40.2301 23.7516 41.1392 23.8034 41.9119 24.3672C42.6903 24.9252 43.0369 25.7767 42.6903 26.2657H42.696Z",
    fill: "#EDF4E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3160_42001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 60,
    fill: "white",
    transform: "translate(0.644531 0.646484)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.dbfaba5a952447dcfd37603111fd0c77.svg";
export { ForwardRef as ReactComponent };